// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__YdVNn","productName":"Table_productName__10gs7"};